import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./chevron-up.svg"; export default path + "#$"